'use strict';

var util = require('./util');

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-utils/node_modules/ajv/lib/compile/schema_obj.js
// module id = GjJD
// module chunks = 11